/**
 * Module dependencies.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { routes } from 'src/core/constants/routes';
import { axiosInstance, getApiEndpoint } from 'src/core/utils/requests';

/**
 * Export `logout` request.
 */

export async function logout() {
  try {
    const response = await axiosInstance.post(getApiEndpoint('revokeToken'));

    return response?.data;
  } catch {
    return;
  }
}

/**
 * `LogoutOptions` type.
 */

type LogoutOptions = {
  expired?: boolean;
};

/**
 * Export `useLogout` hook.
 */

export function useLogout(options?: LogoutOptions) {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: logout,
    onSuccess: async () => {
      await router.push(`${routes.authentication.signIn}${options?.expired ? '?session=expired' : ''}`);

      // Clear only after leaving the page, so mounted private pages never render without their data.
      queryClient.clear();
    }
  });
}
